import React, { useEffect, useRef, useState } from "react";
import HomePageCards from "../HomePageCards/HomePageCards";
import "./LandingPage.css";
import Box from "@mui/material/Box";
import LandingPageCarousel from "../Carousel/LandingPageCarousel";
import Acknowledgement from "../Acknowledgement/Acknowledgement";
import HighlightsSectionLP from "../Highlights/HighlightCardArea/HighlightsSectionLP";
import scaLogo from "../../assets/Images/Logos/SCALogo.png";
import LoadingSpinner from "../../shared/components/LoadingSpinner/LoadingSpinner";

const LandingPage = () => {
  const [showContent, setShowContent] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => setShowContent(true), 750);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!showContent) return;
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !scrolled) {
            setScrolled(true);
            obs.disconnect();
          }
        });
      },
      { root: null, rootMargin: "200px 0px 0px 0px", threshold: 0 }
    );
    if (containerRef.current) observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, [showContent, scrolled]);


  if (!showContent) {
    return (
      <div className="landingPageLoadingWrapper">
        <LandingPageCarousel />
        <div style={{ display: "flex", justifyContent: "center", marginTop: "5rem" }}>
          <LoadingSpinner />
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="carouselWrapper">
        <LandingPageCarousel />
      </div>

      <div ref={containerRef} className="landingPageWrapper">
        <div className="scaLandingMercyContainer">
          <img className="scaLandingLogo" src={scaLogo} alt="SCA Logo" />
          <Box sx={{ textAlign: "center" }}>
            <div className={`scrollingText ${scrolled ? "scrolled" : ""}`}>
              <h1 className="scaLabel">SAINT CATHERINE ACADEMY</h1>
              <h1 className="mercyLabel">A Mercy Center of Excellence and Innovation</h1>
              <h1 className="englishResourcesLabel">Language Department</h1>
            </div>
          </Box>
          <img className="scaLandingLogo" src={scaLogo} alt="SCA Logo" />
        </div>
      </div>

      <Box sx={{ background: "#352475 !important" }}>
        <Acknowledgement />
      </Box>

      <Box sx={{ background: "gold", mt: 0, py: 4, px: 2 }}>
        <HighlightsSectionLP />
      </Box>

      <Box sx={{  }}>
        <HomePageCards />
      </Box>
    </>
  );
};

export default LandingPage;
